import React from 'react';
import Lottie from 'react-lottie';
import lightOverlayAnimationData from '../../../assets/loginFormBgLight.json';
import darkOverlayAnimationData from '../../../assets/loginFormBgDark.json';
import lightAnimationData from '../../../assets/BgLight.json';
import darkAnimationData from '../../../assets/BgDark.json';
import { BackgroundWrapper, AnimationBox } from '../styles';
import type { AuthBackgroundProps } from './types';

const AuthBackground: React.FC<AuthBackgroundProps> = ({ isDarkMode }) => {
  const baseAnimationData = isDarkMode ? darkAnimationData : lightAnimationData;
  const overlayAnimationData = isDarkMode ? darkOverlayAnimationData : lightOverlayAnimationData;

  const baseOptions = {
    loop: false,
    autoplay: true,
    animationData: baseAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const overlayOptions = {
    loop: false,
    autoplay: true,
    animationData: overlayAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  };

  return (
    <BackgroundWrapper>
      <AnimationBox>
        <Lottie options={baseOptions} />
      </AnimationBox>
      <AnimationBox>
        <Lottie options={overlayOptions} />
      </AnimationBox>
    </BackgroundWrapper>
  );
};

export default AuthBackground;
